import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_GREEN } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track7DBlue = ({ state, workState, onLabelClick, id }) => (
	<g id="Track-7D-blue" transform="translate(1398.023846, 978.000000)">
		<path
			d="M3.27101652,16.7400996 L98.0540787,7.12430229"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(5.488947, 16.523419) rotate(-7.000000) translate(-5.488947, -16.523419) "
			points="9.4889468 24.5234191 1.4889468 16.5234191 9.4889468 8.52341911"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, id || 'Track7DBlue')}
			coords="16.976154, 0.000000"
			text="7D"
			textCoordsX="11.0693359"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_GREEN)}
		/>
	</g>
);

Track7DBlue.propTypes = trackPropTypes;

export default Track7DBlue;
